const FooterCompany = () => {
    return (
        <div className="widget">
            <h3 className="widget-title mb-30">회사</h3>
            <ul>
                <li><a href="https://www.wiselight.kr/">회사소개</a></li>
            </ul>
        </div>
    )
}

export default FooterCompany;